export const BAR_START = 5 * 60;   // 05:00
export const BAR_END = 21 * 60;    // 21:00
export const BAR_TICKS = [6, 9, 12, 15, 18, 21];

const minuten = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d.getHours() * 60 + d.getMinutes();
};

const hhmm = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const TijdbalkTicks = ({ className = "" }) => (
  <span className={`flex justify-between text-[9px] font-semibold normal-case tracking-normal text-muted-foreground/80 ${className}`}>
    {BAR_TICKS.map((u) => <span key={u}>{u}u</span>)}
  </span>
);

/** Horizontale balk 05:00–21:00 met de werkelijke tijdsspanne. */
export const Tijdbalk = ({ startIso, eindIso, leegTekst = "—", kleur = "#002FA7", bezigKleur = "#38A169" }) => {
  const start = minuten(startIso);
  if (start === null) {
    return <span className="text-[10px] text-muted-foreground">{leegTekst}</span>;
  }
  const nu = new Date().getHours() * 60 + new Date().getMinutes();
  const dagen = (() => {
    if (!eindIso) return 0;
    const a = new Date(startIso);
    const b = new Date(eindIso);
    if (Number.isNaN(b.getTime())) return 0;
    return Math.round((b.setHours(0, 0, 0, 0) - a.setHours(0, 0, 0, 0)) / 86400000);
  })();
  const eind = dagen > 0 ? BAR_END : (minuten(eindIso) ?? Math.max(nu, start + 5));
  const bezig = !eindIso;
  const clamp = (m) => Math.min(Math.max(m, BAR_START), BAR_END);
  const links = ((clamp(start) - BAR_START) / (BAR_END - BAR_START)) * 100;
  const breedte = Math.max(((clamp(eind) - clamp(start)) / (BAR_END - BAR_START)) * 100, 1.5);
  return (
    <span
      className="relative block h-5 w-full bg-muted/60 rounded-sm overflow-hidden"
      title={`${hhmm(startIso)} → ${hhmm(eindIso) || "nu"}`}
    >
      {BAR_TICKS.map((u) => (
        <span
          key={u}
          className="absolute top-0 bottom-0 w-px bg-border"
          style={{ left: `${((u * 60 - BAR_START) / (BAR_END - BAR_START)) * 100}%` }}
        />
      ))}
      <span
        className="absolute top-1 bottom-1 rounded-sm"
        style={{
          left: `${links}%`,
          width: `${breedte}%`,
          backgroundColor: bezig ? bezigKleur : kleur,
          opacity: bezig ? 0.85 : 0.7,
        }}
      />
      {dagen > 0 && (
        <span className="absolute right-1 top-1 bottom-1 flex items-center px-1 rounded-sm bg-white/85 text-[9px] font-bold text-foreground">
          +{dagen}d
        </span>
      )}
    </span>
  );
};
